export default {
explore_by: "explorar por",
explore_by_concepts: "ideias",
explore_by_families: "famílias olfativas",
language: "idioma",
legal: "informações legais",
find_any_fragrance: "encontre qualquer fragrância no mundo.",
title_by_concepts: "explorar por ideias",
desc_by_concepts: "encontre sua fragrância pensando na sua cor ou lugar favorito",
title_by_families: "explorar por famílias",
desc_by_families: "encontre sua fragrância pensando em ...",
expert_reviewed: "avaliado por especialistas",
ingredients: "ingredientes",
description: "descrição",
perfumist: "perfumista",
concepts: "conceitos",
olfactive_family: "família olfativa",
main_family: "família",
sub_family: "subfamília",
me_family: "Fragrâncias do Mundo",
filter_by_family: "famílias",
filter_by_brand: "marcas",
filter_by_gender: "gênero",
for_him: "para ele",
for_her: "para ela",
unisex: "unissex",
all: "todos",
all_female: "todos",
concepts_list: "lista de conceitos",
no_results_for_this_combination: "nenhum perfume para esta combinação.",
select_at_least_one_concept: "selecione pelo menos um conceito",
view_perfumes: "ver perfumes",
back: "voltar",
close: "fechar",
filters: "filtros",
selected_concepts: "conceitos selecionados:",
selected_families: "famílias selecionadas:",
find_concept: "procurar conceitos...",
smell_of: "cheiro de",
touch_of: "com um toque de",
loading_perfumes: "carregando perfumes",
loading_concepts: "carregando conceitos",
apply: "aplicar",
search: "pesquisar",
clear_all: "limpar tudo",
iconic_fragrances: "fragrâncias icônicas desta família",
is_there_anybody_here: "você ainda está aqui?",
continue_previous_session: "sim! vamos continuar",
reset_session: "reiniciar a experiência",
ingredient_type: "tipo",
ingredient_parts: "parte(s) usada(s)",
ingredient_extraction: "método de extração",
ingredient_first: "perfume icônico",
history: "história",
effect: "produção e efeito",
origin: "origem",
iconic_fragrance: "fragrância icônica",
production: "produção",
loyalty_become_a_member: "Junte-se ao clube",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}